'use strict'

var G = require('window-or-global')

module.exports = function() {
  return (
    typeof G.Promise === 'function' &&
    typeof G.Promise.prototype.then === 'function'
  )
}



//////////////////
// WEBPACK FOOTER
// ./~/can-promise/index.js
// module id = 281
// module chunks = 0